import { ButtonGroup, LinkButton } from "@digipost/dds-buttons-react";
import { Heading } from "@digipost/dds-heading-react";
import * as Sentry from "@sentry/react";
import { FC, useEffect } from "react";
import { Link, useRouteError } from "react-router";

import styles from "../errorpage/ErrorPage.module.less";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { useTranslate } from "../infrastructure/hooks/useTranslate";
import { logError } from "../infrastructure/serverlog";

const OAuthErrorPage: FC = () => {
  const translate = useTranslate();
  const rootPath = useRootPath();

  const error = useRouteError();

  useEffect(() => {
    const sentryEventId = Sentry.captureException(error);
    logError(error, { origin: OAuthErrorPage.name, sentryEventId });
  }, [error]);

  return (
    <article className={styles.errorContent}>
      <img
        className={styles.oauthIllustration}
        src="/innlogging/images/illustrations/hund-snuser-pakke.svg"
        alt={translate("errorpage.illustration_alt")}
      />
      <div className={styles.errorContentText}>
        <Heading size={"medium"} level={2}>
          <Translated textKey={"generic.error_header"} />
        </Heading>

        <p>
          <Translated textKey={"oauth.error_text"} />
        </p>

        <ButtonGroup className={styles.errorContentLinks}>
          <LinkButton
            className={styles.oauthLink}
            as={Link}
            to={`${rootPath}/`}
          >
            <Translated textKey={"errorpage.back_to_login"} />
          </LinkButton>
          <LinkButton
            className={styles.oauthLink}
            as={Link}
            to={`${rootPath}/business`}
          >
            <Translated textKey={"errorpage.back_to_login_company"} />
          </LinkButton>
        </ButtonGroup>
      </div>
    </article>
  );
};

export default OAuthErrorPage;
